export default __webpack_public_path__ + "b125673f6228955e552b9d3ff9dcf9db.svg";